export default __webpack_public_path__ + "static/media/389.11d73ffe.gif";